var __jsx = React.createElement;
import React from 'react';
import { connect } from 'react-redux';
import { theme } from '@spa/offer/theme';
import Share from '@spa/shared/svg/share';
import { Action, Actions } from './styles';
import { modalIds } from '../../modal-displayer';
import HeartOutline from '@spa/shared/svg/heart-outline';
import { showModalAction } from '@spa/shared/store/actions/modal';
import { addToWishlistAction, removeFromWishlistAction } from '@spa/shared/store/actions/profile';
var ShareAndWishlist = function ShareAndWishlist(_ref) {
  var offerId = _ref.offerId,
    city = _ref.city,
    isLoggedIn = _ref.isLoggedIn,
    isWishlistLoading = _ref.isWishlistLoading,
    isOnWishlist = _ref.isOnWishlist,
    showWishlistModal = _ref.showWishlistModal,
    showShareModal = _ref.showShareModal,
    addToWishlist = _ref.addToWishlist,
    removeFromWishlist = _ref.removeFromWishlist;
  var handleWishlistClick = function handleWishlistClick() {
    if (!isLoggedIn) {
      showWishlistModal();
      return;
    }
    isOnWishlist ? removeFromWishlist({
      offerId: offerId,
      city: city
    }) : addToWishlist({
      offerId: offerId,
      city: city
    });
  };
  return __jsx(Actions, null, __jsx(Action, {
    role: 'button',
    onClick: handleWishlistClick,
    isLoading: isWishlistLoading
  }, __jsx(HeartOutline, {
    color: theme.photosModal.shareAndWishlist.color,
    strokeWidth: 1,
    filled: isOnWishlist
  })), __jsx(Action, {
    role: 'button',
    onClick: showShareModal
  }, __jsx(Share, {
    color: theme.photosModal.shareAndWishlist.color
  })));
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var _wishlist$cities;
  var _ref2$offer$offerAggr = _ref2.offer.offerAggregate,
    offerId = _ref2$offer$offerAggr.accommodation_offer.id,
    city = _ref2$offer$offerAggr.globalization_aggregate.city.configuration.slug,
    _ref2$profile = _ref2.profile,
    isLoggedIn = _ref2$profile.isLoggedIn,
    wishlist = _ref2$profile.wish_list;
  var isOnWishlist = wishlist === null || wishlist === void 0 ? void 0 : (_wishlist$cities = wishlist.cities) === null || _wishlist$cities === void 0 ? void 0 : _wishlist$cities.items.some(function (_ref3) {
    var accommodation_offer_ids = _ref3.accommodation_offer_ids;
    return accommodation_offer_ids.includes(offerId);
  });
  return {
    offerId: offerId,
    city: city,
    isLoggedIn: isLoggedIn,
    isOnWishlist: isOnWishlist,
    isWishlistLoading: wishlist === null || wishlist === void 0 ? void 0 : wishlist.isLoading
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showWishlistModal: function showWishlistModal() {
      return dispatch(showModalAction({
        modalId: modalIds.WISHLIST
      }));
    },
    showShareModal: function showShareModal() {
      return dispatch(showModalAction({
        modalId: modalIds.SHARE
      }));
    },
    addToWishlist: function addToWishlist(_ref4) {
      var offerId = _ref4.offerId,
        city = _ref4.city;
      return dispatch(addToWishlistAction({
        offerId: offerId,
        city: city
      }));
    },
    removeFromWishlist: function removeFromWishlist(_ref5) {
      var offerId = _ref5.offerId,
        city = _ref5.city;
      return dispatch(removeFromWishlistAction({
        offerId: offerId,
        city: city
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ShareAndWishlist);